import { useNavigate } from 'react-router-dom';
import { useAppStore } from '@/store/AppStore';

export default function OperationFunnel() {
  const { requests, quotes, jobs, appointments } = useAppStore();
  const navigate = useNavigate();

  const videoReceived = requests.filter((r) => r.videoStatus === 'Video Geldi').length;
  const approved = quotes.filter((q) => q.status === 'Onaylandı').length;
  const completed = jobs.filter((j) => j.status === 'Kapandı').length;

  const stages = [
    { label: 'Yeni Talep', value: requests.length, path: '/teklif-talepleri' },
    { label: 'Video Geldi', value: videoReceived, path: '/teklif-talepleri' },
    { label: 'Teklif', value: quotes.length, path: '/teklifler' },
    { label: 'Onay', value: approved, path: '/teklifler' },
    { label: 'Randevu', value: appointments.length, path: '/randevu' },
    { label: 'Tamamlandı', value: completed, path: '/tamamlanan-isler' },
  ];

  const max = Math.max(...stages.map((s) => s.value), 1);

  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-white p-5">
      <div className="flex items-center justify-between">
        <h2 className="font-heading text-[15px] font-bold text-foreground-950">Operasyon Hunisi</h2>
        <span className="text-xs font-semibold text-foreground-400">Uçtan uca akış</span>
      </div>
      <div className="mt-4 grid grid-cols-3 gap-3 sm:grid-cols-6">
        {stages.map((s) => (
          <button
            key={s.label}
            type="button"
            onClick={() => navigate(s.path)}
            className="group flex flex-col items-center rounded-lg bg-background-50 p-3 text-center transition-colors hover:bg-primary-50"
          >
            <div
              className="h-2 w-full rounded-full bg-primary-500/20"
            >
              <div
                className="h-2 rounded-full bg-primary-500 transition-all group-hover:bg-accent-500"
                style={{ width: `${Math.max(8, Math.round((s.value / max) * 100))}%` }}
              />
            </div>
            <div className="mt-2 font-heading text-xl font-bold text-foreground-950">{s.value}</div>
            <div className="mt-0.5 text-[11px] font-semibold text-foreground-500">{s.label}</div>
          </button>
        ))}
      </div>
    </div>
  );
}